<template>
  <div>
    <router-view></router-view>
    <v-snackbar v-model="$store.state.alert" :timeout="2500" variant="flat" color="transparent" class="mb-4">
      <v-alert
        closable
        @click:close="$store.state.alert = false"
        :type="$store.state.typeAlert"
        dir="auto"
        :max-height="128"
      >
        {{ $store.state.textAlert }}
      </v-alert>
    </v-snackbar>
    <v-expand-transition>
      <v-card
        v-show="showUpdateUI"
        color="primary-50"
        position="fixed"
        :title="$t('new_version_of_monitait')"
        :text="$t('press_button_update')"
        stacked
        class="px-6 py-4 elevation-16"
        style="z-index: 10000"
        :class="$store.state.desktop ? 'w-25 rounded-t-lg' : 'w-100 rounded-b-lg'"
        :style="$store.state.desktop ? 'bottom: 0; left: 37.5%;' : 'top: 0; left: 0;'"
      >
        <template v-slot:actions>
          <v-btn color="primary" text @click="accept">{{ $t('accept') }}</v-btn>
        </template>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import update from './mixin/update'
export default {
  name: 'App',
  computed: {
    rtl() {
      return localStorage.getItem('lang') === 'fa' || false
    },
  },
  data: () => ({
    showUpdateUI: false,
  }),
  mixins: [update],
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.showUpdateUI = true
      })
    }
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    async accept() {
      this.showUpdateUI = false
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' })
    },
    handleResize() {
      this.$store.state.desktop = window.innerWidth >= 1280 ? true : false
    },
  },
}
</script>

<style>
@font-face {
  font-family: 'Vazir';
  src: url('@/assets/fonts/vazir.woff2');
  font-display: swap;
}
@font-face {
  font-family: 'SF UI Display';
  src: url('@/assets/fonts/sf-ui-display.otf');
  font-display: swap;
}
html,
body {
  font-family: 'SF UI Display', Vazir, sans-serif !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0 !important;
}
html {
  padding: 0 !important;
}
input[type='datetime-local'] {
  display: inline-block;
}
.v-select__content > .v-list {
  overscroll-behavior: contain;
}
</style>
